export default {
	data() {
		return {
			manobra: null
		}
	},
	methods: {
		filterManobra(manobra) {
			return this.form.manobras.some((id) => id == manobra.id)
		},
		selectManobra(manobra) {
			if (manobra && !this.form.manobras.find((item) => item == manobra.id)) {
				this.form.manobras.push(manobra.id)
			}
		},
		deleteManobra(manobra) {
			const index = this.form.manobras.findIndex((item) => item == manobra.id)
			if (index > -1) {
				this.form.manobras.splice(index, 1)
				this.form.usuario_manobra = this.form.usuario_manobra.filter(
					(item) => item.id_manobra != manobra.id
				)
			}
		},
		removeRelation(usuarioId, manobraId) {
			const index = this.form.usuario_manobra.findIndex(
				(item) => item.id_usuario == usuarioId && item.id_manobra == manobraId
			)
			if (index > -1) {
				this.form.usuario_manobra.splice(index, 1)
			}
		},
		checkUsuariosManobra(manobra) {
			this.form.tripulacao.forEach((trip) => {
				this.checkManobra(trip.id_usuario, manobra.id, false)
			})
		},
		removeUsuariosManobra(manobra) {
			this.form.tripulacao.forEach((trip) => {
				this.removeRelation(trip.id_usuario, manobra.id)
			})
		},
		checkManobrasUsuario(usuario) {
			this.form.manobras.forEach((id) => {
				this.checkManobra(usuario.id_usuario, id, false)
			})
		},
		removeManobrasUsuario(usuario) {
			this.form.manobras.forEach((id) => {
				this.removeRelation(usuario.id_usuario, id)
			})
		},
		checkManobra(usuarioId, manobraId, remove = true) {
			const index = this.form.usuario_manobra.findIndex(
				(item) => item.id_usuario == usuarioId && item.id_manobra == manobraId
			)
			if (index > -1) {
				if (remove) {
					this.form.usuario_manobra.splice(index, 1)
				}
			} else {
				this.form.usuario_manobra.push({
					id_usuario: usuarioId,
					id_manobra: manobraId
				})
			}
		}
	}
}